import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class AbstractIcon extends Component {
    static propTypes = {
        viewBox: PropTypes.string,
    };

    render() {
        const { children } = this.props;

        return (
            <svg xmlns="http://www.w3.org/2000/svg" {...this.props}>
                {children}
            </svg>
        );
    }
}
